<template>
  <div>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
          <ul v-if='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <fieldset>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>الفرع:</label>
            <select @change='FillItineraries($event.target.value)' class="form-control" style="padding: 0px" v-model="record.branche_id">
              <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <vue-element-loading size='32' :active='isLoadingItineraries' spinner='bar-fade-scale' color='#A4A4A4'/>
            <label>الخط:</label>
            <select @change='FillRegions($event.target.value)'  class="form-control" style="padding: 0px" v-model="record.line_id">
              <option v-for="line in lines" v-bind:key="line.id" v-bind:value="line.id">
                {{ line.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <vue-element-loading size='32' :active='isLoadingRegions' spinner='bar-fade-scale' color='#A4A4A4'/>
            <label>المنطقة:</label>
            <select class="form-control" style="padding: 0px" v-model="record.region_id">
              <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.region_name }}
              </option>
            </select>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>الاسم:</label>
            <input v-model='record.name' class='form-control' name='name' type='text'>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>اسم الشهرة:</label>
            <input v-model='record.nickname' class='form-control' name='nickname' type='text'>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <div>
              <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 0px">
                <div class="form-group">
                  <label>رقم السجل</label>
                  <input v-model='record.rec_id' class='form-control' name='nickname' type='text'>
                </div>
              </div>
              <div class='col-lg-6 col-md-6 col-sm-6 form-group' style="padding: 0px 5px 0px 0px;">
                  <label>حالة المراجعة</label>
                  <select style="padding: 0px" class="form-control" v-model="record.reviewType">
                    <option value='0'>بدون مراجعه</option>
                    <option value='1'>مراجعة أولى</option>
                    <option value='2'>مراجعة ثانية</option>
                    <option value='3'>مراجعة ثالثة</option>
                  </select>
              </div>
            </div>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>المحافظة:</label>
            <select  @change='FillCitys()' class="form-control" style="padding: 0px" v-model="record.governorate">
              <option v-for="(item) in governorates" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>المدينة:</label>
            <vue-element-loading size='32' :active='isLoadingCitys' spinner='bar-fade-scale' color='#A4A4A4'/>
            <select class="form-control" style="padding: 0px" v-model="record.city">
              <option v-for="(city) in cities" v-bind:key="city.id" v-bind:value="city.id">
                {{ city.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>القرية:</label>
            <input v-model='record.village' class='form-control' name='village' type='text'>
          </div>
          <div class='col-lg-6 col-md-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>العنوان:</label>
            <input v-model='record.address' class='form-control' name='address' type='text'>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <div class="form-group">
              <label>محمول1</label>
              <div class="form-group input-group">
                <input v-model='record.mobile' class='form-control' name='nickname' type='text'>
                  <span class="input-group-btn">
                    <button
                      class="btn btn-default"
                      type="button"
                      title="تواصل عبر واتساب"
                      @click="openWhatsapp(record.mobile)"
                    >
                      📞
                    </button>
                  </span>
              </div>
            </div>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <div class="form-group">
              <label>محمول2</label>
              <div class="form-group input-group">
                <input v-model='record.mobile2' class='form-control' name='nickname' type='text'>
                  <span class="input-group-btn">
                    <button
                      class="btn btn-default"
                      type="button"
                      title="تواصل عبر واتساب"
                      @click="openWhatsapp(record.mobile2)"
                    >
                      📞
                    </button>
                  </span>
              </div>
            </div>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>رقم البطاقة:</label>
            <input v-model='record.idcard' class='form-control' name='idcard' type='text'>
          </div>
          <div class='col-lg-2 col-md-2 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>التقييم:</label>
            <select class="form-control" style="padding: 0px" v-model="record.evaluation">
              <option v-for="evalu in evalus" v-bind:key="evalu.id" v-bind:value="evalu.id">
                {{ evalu.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-2 col-md-2 col-sm-6' style='padding: 10px 0px 0px 10px;'>
            <label>الحالة:</label>
            <select class="form-control" style="padding: 0px" v-model="record.active">
              <option v-for="type in types" v-bind:key="type.id" v-bind:value="type.id">
                {{ type.name }}
              </option>
            </select>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-6 form-group input-group" style='padding: 10px 0px 0px 10px;'>
            <label>الموقع:</label>
            <input v-model='record.location' class='form-control' name='idcard' type='text'>
            <span v-if="record.location" class="input-group-btn" style='padding: 24px 0px 0px 0px;'>
                <button @click="openLocation(record.location)" class="btn btn-default" type="button"><i class="fa fa-map-marker"></i>
                </button>
            </span>
          </div>
          <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;'>
            <label>ملاحظات:</label>
            <textarea class="form-control" rows="6" v-model="record.notes"></textarea>
          </div>
          <!-- <div class='col-lg-12 col-sm-12' style='padding: 35px 0px 10px 10px;   text-align:center;'>
            <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
            <button @click='saveData'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
          </div> -->
        </fieldset>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Data',

  data () {
    return {
      validationErrors: '',
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingSave: false,
      isLoadingItineraries: false,
      isLoadingRegions: false,
      isLoadingCitys: false,
      isLoadingDelete: false,
      types: [{id: 1, name: 'نشط'}, {id: 0, name: 'غير نشط'}],
      evalus: [{id: 0, name: 'غير مقيم'}, {id: 1, name: 'سيئ جدا'}, {id: 2, name: 'سيئ'}, {id: 3, name: 'جيد'}, {id: 4, name: 'جيد جدا'}],
      branches: {},
      brancheID: 0,
      governorates: {},
      cities: {},
      lines: {},
      regions: {},
      contTitle: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.brancheID = localStorage.getItem('BrancheID')
    this.governorates = JSON.parse(localStorage.getItem('Gov'))
  },
  methods: {
    isValidMobile (mobile) {
      if (!mobile) return false

      const phone = mobile.toString().replace(/[^0-9]/g, '')
      return phone.length === 11
    },
    // ===============================================================
    openWhatsapp (mobile) {
      if (!this.isValidMobile(mobile)) return

      const phone = mobile.toString().replace(/[^0-9]/g, '')
      const finalPhone = '20' + phone

      const url = `https://wa.me/${finalPhone}`
      window.open(url, '_blank')
    },
    // ===============================================================
    openLocation (location) {
      window.open(
        'https://www.google.com/maps?q=' + location,
        '_blank'
      )
    },
    // ===============================================================
    FillData (CustID) {
      this.isLoadingSave = false
      this.errorShow = false
      this.successShow = false
      if (CustID === 0) {
        this.record = {'id': 0, 'line_id': '', 'branche_id': '', 'rec_id': '', 'name': '', 'governorate': '', 'city': '', 'village': '', 'address': '', 'mobile': '', 'mobile2': '', 'idcard': '', 'active': 1, 'nickname': '', 'evaluation': 0, 'region_id': 0, 'rec_id_letter': '', 'location': '', 'reviewType': 0}
      } else {
        this.record = this.$store.state.customerData
        this.FillCitys(this.record.governorate)
        this.FillItineraries(this.record.branche_id)
        this.FillRegions(this.record.line_id)
      }
    },
    FillCitys () {
      this.isLoadingCitys = true
      axios.post(this.$apiURL + 'get-branch-cities', {
        token: localStorage.getItem('token'),
        governorate: this.record.governorate
      })
        .then(res => {
          this.isLoadingCitys = false
          this.cities = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    FillItineraries (id) {
      this.regions = ''
      this.isLoadingItineraries = true
      axios.post(this.$apiURL + 'get-branch-itineraries', {
        token: localStorage.getItem('token'),
        branch: this.record.branche_id
      })
        .then(res => {
          this.isLoadingItineraries = false
          this.lines = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    FillRegions (id) {
      this.isLoadingRegions = true
      axios.post(this.$apiURL + 'get-branch-regions', {
        token: localStorage.getItem('token'),
        line: this.record.line_id
      })
        .then(res => {
          this.isLoadingRegions = false
          this.regions = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveCustomer', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        branche_id: this.record.branche_id,
        line_id: this.record.line_id,
        region_id: this.record.region_id,
        rec_id: this.record.rec_id,
        rec_id_letter: this.record.rec_id_letter,
        name: this.record.name,
        governorate: this.record.governorate,
        city: this.record.city,
        village: this.record.village,
        address: this.record.address,
        mobile: this.record.mobile,
        mobile2: this.record.mobile2,
        idcard: this.record.idcard,
        active: this.record.active,
        nickname: this.record.nickname,
        notes: this.record.notes,
        evaluation: this.record.evaluation,
        reviewType: this.record.reviewType,
        location: this.record.location
      })
        .then(res => {
          this.$root.$emit('SET_Records', res.data[0], this.record.id)
          this.isLoadingSave = false
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
          this.record.id = res.data[0].id
          this.$store.dispatch('getAllCustomerData', res.data[0])
          this.$root.$emit('SET_Title', '[' + 'كود سجل ' + this.$store.state.customerData.rec_id + ']' + this.$store.state.customerData.name + ' ' + '[' + 'العقد ' + this.$store.state.customerData.contract_id + ']')
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/Data.vue